import BaseRegulation from '../../base_regulation';
import Store from "../../../../../utils/store";
import OntarioResponsibleGamingIconsController
    from "../../../../../components/regulation_components/canada/ontario/responsible_gaming_icons/ontario_responsible_gaming_icons_controller";
import Event from "../../../../../utils/event";
import {SYSTEM_EVENTS} from "../../../../../events/events";
import Device from '../../../../../utils/device/device';
import {GNWP_SOURCES} from "../../../../../components/external_links/external_links_consts";

export default class CanadaOntarioRegulation extends BaseRegulation {
    static CLASS = 'CanadaOntarioRegulation';

    checkIfCorrectAppInUse(country:string, state: string) {
        const canadaWrongAppAppsFlyerSmartLink = "https://888casino-ca.onelink.me/3A45/wrongAppCta?pid=cta_WrongApp&af_sub2=";

        if (Device.hybrid.inCasino && !Device.hybrid.isEmbedded && Device.os.isIOS) {
            this.serviceFactory.hybridVersionHandlerService().showUserWrongAppMessage(canadaWrongAppAppsFlyerSmartLink + this.serviceFactory.hybridService().getSmartLinkData());
            this.sendAnalytics('userWrongAppMessage', 'show');
        }
    }

    overrideCurrencySymbol(): string {
        return '$';
    }

    showNetPosition(): boolean {
        return true;
    }

    shouldCallCountryByIP(country:string) {
        return true;
    }

    onStateNotInListClickHandler() {
        this.serviceFactory.windowService().redirect(this.serviceFactory.skinService().getWrongLocationDetectionPath());
    }

    fitToPlayModeEnabled(): boolean {
        return true;
    }

    showAgeResponsibleIconInGame() {
        return false;
    }

    showResponsibleIcons() {
        return true;
    }

    getResponsibleGamingIconsComponent(params){
        return OntarioResponsibleGamingIconsController.create(params);
    }

    stepsBeforeOpenLoginAndRegistration():Promise<void> {
        return new Promise((resolve, reject) => {
            const STATE_POPUP_KEY = 'state-popup'
            if(Store.get(STATE_POPUP_KEY)) {
                return resolve();
            }
            return this.serviceFactory.orbitComponentRenderService().showLocationPopup({
                stateName: "Ontario",
                onStateSelect: ()=> {
                    Store.set(STATE_POPUP_KEY, true);
                    return resolve();
                },
                onStateNotInListClick: ()=> {
                    this.onStateNotInListClickHandler();
                    reject();
                },
                onMessageClosed: ()=> {
                    Event.fire(SYSTEM_EVENTS.LOCATION_POPUP_CLOSED);
                    return reject();
                }
            });
        });
    }

    runConditionsBeforeOpenLink(source: string):Promise<void> {
        if(source !== GNWP_SOURCES.MEMBERSHIP) {
            return Promise.resolve();
        }

        return this.stepsBeforeOpenLoginAndRegistration();
    }

    getExternalLinksConfig() {
        return {
            'membership': {
                isCloseBtnAllowed: false
            },
            'upload_document': {
                isCloseBtnAllowed: false
            }
        };
    }

    private sendAnalytics(category:string, action:string):void {
        const analyticsData:any = {
            CGPEventCategory: category,
            CGPEventAction: action
        };

        this.logger.debug(action, JSON.stringify(analyticsData));
        this.serviceFactory.structuredLoggingService().getLogger(analyticsData).info();
    }
}